import { Component, Input, OnInit } from '@angular/core';
import { OtherRequirement } from 'src/app/locums/models/other-requirement.interface';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { deaCode } from 'src/app/locums/locums-constants';

@UntilDestroy()
@Component({
  selector: 'nova-locums-recruiter-dea',
  templateUrl: './locums-recruiter-dea.component.html',
  styleUrls: ['./locums-recruiter-dea.component.scss']
})
export class LocumsRecruiterDeaComponent implements OnInit {

  otherRequirement: OtherRequirement;
  @Input() jobId: number;

  constructor(private readonly locumsJobService: LocumsJobService) { }

  ngOnInit(): void {
    this.getUnitOtherRequirements(this.jobId);
  }

  getUnitOtherRequirements(jobId: number): void {
    this.locumsJobService
      .getUnitOtherRequirements(jobId)
      .pipe(untilDestroyed(this))
      .subscribe((otherRequirements: OtherRequirement[]) => {
        this.otherRequirement = otherRequirements?.filter((x) => x.lookupOtherRequirementId === deaCode)[0];
      });
  }

}
